import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Paper, Button } from '@material-ui/core';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';

import styles from '../App.css';
import componentStyles from './CreateNewCase.css';
import JsonForm from '../../components/JsonForm/JsonForm'

import '../ViewCustomerCase/ViewCustomerCase.css';
import LanguageMenu from '../../components/LanguageMenu/LanguageMenu';
import Translation from '../../components/Translation/Translation';

const style = {
  languageMenuContainer: {
    marginTop: -20,
    marginLeft: -40,
    marginRight: -40,
    borderBottom: "1px solid black"
  },

  languageMenu: {
    paddingTop: 10,
    paddingLeft: 40
  }
}

@inject('formDataStore')
@inject('languageStore')
@observer
export default class CreateNewCase extends Component {
  constructor(props) {
    super(props);
    this.updateProperty = this.updateProperty.bind(this);

    this.state = {
      language: this.props.languageStore.language
    }
  }

  changeLanguage(language) {
    this.setState({language}, this.fetchCase);
  }

  fetchCase() {
    let id = this.props.match.params.id; // case _id from url parameter
    this.props.formDataStore.fetchOneCustomerCase(id, this.state.language); // fetch Customer Case by id
  }

  componentDidMount() {
    this.fetchCase();
  }

  updateProperty(key, value) {
    this.props.formDataStore.customerCase.customer[key] = value;
  }

  changeValue(targetObject, id, targetArray, key, event) {
    console.log(event.target.value);
    this.props.formDataStore.assignValueToProperty(
      targetObject,
      id,
      targetArray,
      key,
      event.target.value
    );
  }

  changeValueOnlyNumbers(targetObject, id, targetArray, key, event) {
    console.log(event.target.value);
    if (/[^0-9 ]/.test(event.target.value)) {
      this.props.formDataStore.assignValueToProperty(
        targetObject,
        id,
        targetArray,
        key,
        0
      );
      event.target.value = 0;
    } else {
      this.props.formDataStore.assignValueToProperty(
        targetObject,
        id,
        targetArray,
        key,
        event.target.value
      );
    }
  }

  renderData() {
    if (this.props.formDataStore.formDataState !== 'done') {
      return <CircularProgress />; // wait until the fetch is done and the store is updated
    } else {
      return (
        <div>
          <div style={style.languageMenuContainer}>
            <div style={style.languageMenu}>
              <Typography variant="body1" style={{fontWeight: 500}} inline><Translation>locale</Translation>:</Typography> <LanguageMenu activeLanguage={this.state.language} onClick={this.changeLanguage.bind(this)}/>
            </div>
          </div>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <JsonForm
                mode="edit"
                schema={this.props.customerCaseStore.caseSchema}
                language={this.state.language}
                labelLanguage={this.props.languageStore.language}
              />
            </Grid>
            <Grid
              container
              xs={12}
              style={componentStyles.marginButtonContainerRight}
            >
              <Grid
                item
                xs={12}
                sm={6}
                style={componentStyles.marginButtonContainerLeft}
              >
                <Button
                  component={Link}
                  to={'/case/' + this.props.formDataStore.customerCaseRoot._id}
                  onClick={() => {
                    this.props.formDataStore.saveCustomerCase();
                  }}
                  variant={'contained'}
                  color={'primary'}
                  style={componentStyles.marginButtonContainerLeft}
                >
                  {'Tallenna'}
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                style={componentStyles.marginButtonContainerRight}
              >
                <Button
                  component={Link}
                  to={
                    '/case/' +
                    this.props.formDataStore.customerCaseRoot._id
                  }
                  variant={'contained'}
                  color={'secondary'}
                  style={componentStyles.formCollapseButtonContainerRight}
                >
                  {'Peruuta'}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }
  }
  render() {
    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/CreateNewCase.jsx